import React from "react";
import { Navigate, useLocation, useNavigate, useSearchParams } from "react-router-dom";

type MyProps = {
  to: string;
};

const Redirect: React.FC<MyProps> = (props: MyProps) => {
  const location = useLocation();
  let [searchParams] = useSearchParams();
  // const queryString =
  //   searchParams.size > 0 ? "?" + searchParams.toString() : "";
  const queryString = "";
  //return <Navigate to={props.to + queryString} />;
  const navigate = useNavigate();

  React.useEffect(() => {
    navigate(props.to + queryString);
  }, [location, searchParams.toString()]);

  return <></>;
};

export default Redirect;
